import apis from '@/api'

export default {
  data() {
    return {
      tableHeight: 0,
      resizeHandler: null,
      selectedList: [],
      tableData: [],
      sort: {
        sortField: null,
        sortOrder: null
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.queryListData()
    this.$nextTick(() => {
      this.updateTableHeight()
      this.resizeHandler = this.debounce(this.updateTableHeight, 200)
      window.addEventListener('resize', this.resizeHandler)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    querySearchFieldData(id) {
      this.searchData.field_id = null
      const request = {
        ...apis.QUERY_FIELD_SELECT_LIST,
        params: {
          group_id: [id]
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.fieldList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    queryListData() {
      const request = {
        ...this.queryListApi,
        params: {
          ...this.searchData,
          // sort: this.sort,
          order_by: this.sort.sortField,
          desc: this.sort.sortOrder === 'descending',
          page: this.pagination.currentPage,
          page_size: this.pagination.pageSize
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              if (resp.data.tableData.length === 0 && resp.data.total > 0) {
                const maxPage = Math.ceil(resp.data.total / this.pagination.pageSize)
                this.pagination.currentPage = maxPage
                this.queryListData()
              }
              this.tableData = resp.data.tableData
              this.pagination.total = resp.data.total
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    deleteListRow(data) { // 支持批量删除
      console.log('删除')
      let ids = []
      if (Array.isArray(data)) {
        ids = data.map(item => item[this.deleteListParams.id])
      } else {
        ids.push(data[this.deleteListParams.id])
      }
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(ids)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteRow(row) {
      console.log('删除行：', row)
      const request = {
        ...this.deleteListParams.api
      }
      request.url = request.url + '/' + row
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.queryListData()
              this.$refs.customTableRef.clearSelection()
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    // 搜索栏
    searchSubmit() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.pagination.currentPage = 1
          this.queryListData()
        } else {
          return false
        }
      })
    },
    resetSearch() {
      this.$refs.searchForm.resetFields()
      this.queryListData()
    },
    // 排序
    handleSortChange({ prop, order }) {
      console.log('排序排序排序排序排序排序排序排序排序排序排序排序', prop, order)
      if (order === null) {
        prop = null
      }
      this.sort.sortField = prop
      this.sort.sortOrder = order
      this.pagination.currentPage = 1
      this.queryListData()
    },
    // 多选操作
    handleSelectionChange(selection) {
      console.log('选中的行：', selection)
      this.selectedList = selection
    },
    // 分页操作
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      console.log('切换页码：', page)
      this.queryListData()
    },
    handleSizeChange(size) {
      console.log('每页数量：', size)
      this.pagination.currentPage = 1
      this.pagination.pageSize = size
      this.queryListData()
    },
    // 计算表格高度
    updateTableHeight() {
      const container = this.$el.querySelector('.list-page-wrap')
      if (!container) return

      const containerHeight = container.offsetHeight
      const headerHeight = this.$el.querySelector('.list-page-heaser')?.offsetHeight || 0
      this.tableHeight = containerHeight - headerHeight - 62
    },
    // 防抖函数
    debounce(fn, delay) {
      let timer
      return () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(this)
        }, delay)
      }
    }
  }
}
